const module = { name: 'global/tracking/passiveEvents', exports: {} }; const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_track } from 'require-global';

const { track } = Fandango_adobeLaunch_track;


const Selectors = {
    TRACKABLE: 'js-passive-event',
}
function onClick(e) {
    if (typeof e.composedPath !== 'function') {
        return;
    }
    const element = e.composedPath()
        .find(element => element.classList && element.classList.contains(Selectors.TRACKABLE));
    const event = element && element.dataset.event || '';
    if (event.trim()) {
        track({ event });
    }
}
function attach() {
    document.body.addEventListener('click', onClick);
}
module.exports = {
    attach
};
export default module.exports;